module.exports = __webpack_public_path__ + "static/media/frizo-appointment-book.f8ebb31a.png";